<template>
    <div>
        <Banner></Banner>
        <Partner></Partner>
        <Solutions></Solutions>
        <About></About>
        <!-- <Services></Services>
        <Funfacts></Funfacts> -->
        <!-- <Projects></Projects> -->
        <!-- <Pricing></Pricing> -->
        <Feedback></Feedback>
        <!-- <Blog></Blog> -->
        <Trial></Trial>
    </div>
</template>

<script>
import Banner from './smat-iot/Banner';
import Partner from './smat-iot/Partner';
import Solutions from './smat-iot/Solutions';
import About from './smat-iot/About';
// import Services from './smat-iot/Services';
// import Funfacts from './smat-iot/Funfacts';
// import Projects from './smat-iot/Projects';
// import Pricing from './smat-iot/Pricing';
import Feedback from './smat-iot/Feedback';
// import Blog from './smat-iot/Blog';
import Trial from './smat-iot/Trial';
export default {
    name: 'AiMachineLearning',
    components: {
        Banner,
        Partner,
        Solutions,
        About,
        // Services,
        // Funfacts,
        // Projects,
        // Pricing,
        Feedback,
        // Blog,
        Trial
    }
}
</script>